module.exports = __webpack_public_path__ + "img/hrm-katherine-sm.6c8e50e.png";